import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoginForm from "../components/auth/LoginForm";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleRegisterClick = () => {
    navigate("/register");
  };

  const handleLoginSuccess = (user, tokens) => {
    // Salvar usuário e tokens JWT no contexto de autenticação
    login(user, tokens);
    // Redirecionar baseado no tipo de usuário
    if (user.role === "admin") {
      navigate("/"); // Vai para a página de seleção de admin
    } else {
      navigate("/dashboard"); // Usuários normais vão direto para dashboard
    }
  };

  return <LoginForm onRegisterClick={handleRegisterClick} onSuccess={handleLoginSuccess} />;
};

export default LoginPage;
